import { t } from '@lingui/core/macro';
import { colorSystem, Flexbox, SecondaryButton, StatusIcon, Text, Tooltip } from '@luminovo/design-system';
import type { JSX } from 'react';

export type CompareLineItemVariant = 'current' | 'synced' | 'apply';

interface CompareLineItemActionButtonProps {
    variant: CompareLineItemVariant;
    scenarioName?: string;
    onApply: (copyManualStates: boolean) => void;
    isLoading?: boolean;
    disabled?: boolean;
}

export function CompareLineItemActionButton({
    variant,
    scenarioName,
    onApply,
    isLoading = false,
    disabled = false,
}: CompareLineItemActionButtonProps): JSX.Element {
    if (variant === 'current') {
        // The current card is the baseline, so there's nothing to apply.
        return <></>;
    }

    if (variant === 'synced') {
        return (
            <Flexbox
                gap={8}
                style={{ width: '100%' }}
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <StatusIcon status="success" variant="filled" size={18} />
                <Text variant="body-small" color={colorSystem.green[7]}>
                    {t`Same offer selected`}
                </Text>
            </Flexbox>
        );
    }

    const tooltipText = scenarioName
        ? t`Apply the baseline offer to "${scenarioName}"`
        : t`Apply the baseline offer to this scenario`;

    return (
        <Flexbox
            style={{ width: '100%' }}
            sx={{
                justifyContent: 'center',
            }}
        >
            <Tooltip title={tooltipText}>
                <SecondaryButton size="medium" onClick={() => onApply(false)} disabled={disabled} isLoading={isLoading}>
                    {t`Apply baseline offer`}
                </SecondaryButton>
            </Tooltip>
        </Flexbox>
    );
}
